export default __webpack_public_path__ + "1fc20ed04827b284aeb9817b0c0dfeee.jpg";